import Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const initialState = Immutable.fromJS({
  isFetching: true,
  id: null,
  type: null,
  givenName: null,
  surName: null,
  permissions: [],
  customerData: null,
  takeover: null,
});

function getKey(customerData) {
  return customerData != null ? 'customerData' : 'takeover';
}

export default function user(state = initialState, action) {
  const key = getKey(state.get('customerData'));

  switch (action.type) {
    case ActionTypes.LOGOUT_USER:
      return initialState.set('isFetching', false);

    case ActionTypes.REQUEST_USER_INFO:
      return state.set('isFetching', true);

    case ActionTypes.RECEIVE_USER_INFO:
      return state.merge(Immutable.fromJS(action.data)).merge(
        Immutable.fromJS({
          isFetching: false,
        }),
      );

    case ActionTypes.USER_INFO_SET_BALANCE:
      return state.setIn([key, 'balance'], action.balance);

    case ActionTypes.USER_INFO_SET_MARGIN:
      return state.setIn([key, 'margin'], action.marginInfo);

    case ActionTypes.USER_SET_SELECTED_ACCOUNT:
      const newAccounts = state.getIn([key, 'accounts']).map(account => {
        const isSelected = account.get('customerId') === action.data.customerId;

        return account.set('isSelected', isSelected);
      });

      return state.setIn([key, 'accounts'], newAccounts);

    default:
      return state;
  }
}
